const book =[
    {
        id:1,
        book: "https://drive.google.com/file/d/1Kww620bJy9o92DBjqP_QaWNEbrRdODqv/view?usp=sharing",
        img: "after-effects"
    },

    {
        id:2,
        book: "https://drive.google.com/file/d/1tGJ_gux1IYepA17glIk1DLQ7cSznidsZ/view?usp=sharing",
        img: "photoshop"
    },

    {
        id:3,
        book: "https://drive.google.com/file/d/18m2r5nvGaaw8m9uoGBx5mObMV4kwmNDd/view?usp=sharing",
        img: "illustrator"
    },

    {
        id:4,
        book: "https://drive.google.com/file/d/1wKe6alEwtbiDehnS-jhwxS_eIK3eN3V8/view?usp=sharing",
        img: "indesign"
    },

    {
        id:5,
        book: "https://drive.google.com/file/d/1xGs0_bpzv6lb0lqGWz63fl1bUgxU6kep/view?usp=sharing",
        img: "premier"
    },

    {
        id:6,
        book: "https://drive.google.com/file/d/1kWgO8RAhY7uqpXgllcA4Q_tO7Dr52W4o/view?usp=sharing",
        img: "premier"
    }
]

export default book